export const BASE_URI = "https://transfertlux.com/api/";

// export const AWS_BUCKET_NAME = "transfertflux";
// export const AWS_ACCESS_KEY_ID = "AKIA54CXJKKWRSHWDBPT";
// export const AWS_SECRET_ACCESS_KEY = "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";
// export const AWS_BUCKET_REGION = "us-east-1";
